// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2RhkS","label":"CategoryService_label__NTecm","location":"CategoryService_location__1Nou3"};